import {Alpine} from "alpinejs";
import mask from '@alpinejs/mask';

import zip from "./extensions/alpinejs/zippopotam.us.js";

Alpine.plugin(mask);
Alpine.data('zip', zip);

window.Alpine = Alpine;

Alpine.start();